import { inject, injectable } from "inversify";

import PaymentInfo from "@model/PaymentInfo";
import AssociatedCreateViewModel from "@vm/Create/AssociatedCreateViewModel";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class PaymentInfoCreateVM extends AssociatedCreateViewModel<PaymentInfo, AssociatedRepository<PaymentInfo>> {
  constructor(@inject(TYPES.PaymentInfoRepository) repository: AssociatedRepository<PaymentInfo>) {
    super(PaymentInfo, repository);
  }
}
